import { render, staticRenderFns } from "./DropdownHeader.vue?vue&type=template&id=26db4326&"
import script from "./DropdownHeader.vue?vue&type=script&lang=js&"
export * from "./DropdownHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26db4326')) {
      api.createRecord('26db4326', component.options)
    } else {
      api.reload('26db4326', component.options)
    }
    module.hot.accept("./DropdownHeader.vue?vue&type=template&id=26db4326&", function () {
      api.rerender('26db4326', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/dropdown/DropdownHeader.vue"
export default component.exports